<script lang="ts">
  import { applyHasSlotContentClass } from "../../actions/applyHasSlotContentClass";

  interface Props {
    disabled?: boolean;
  }

  let { disabled = false }: Props = $props();
</script>

<svelte:element
  this={"slot"}
  name="hint"
  class:--disabled={disabled}
  aria-hidden="true"
  use:applyHasSlotContentClass
/>

<style lang="scss">
  @use "@otto-ec/design-tokens/component" as tokens;

  :global {
    slot[name="hint"] {
      display: block;
      font: tokens.$oc-component-form-hint-font;
      color: tokens.$oc-component-form-default-hint-color;
      word-break: break-word;

      /*                       */
      &.--has-slot-content {
        margin-top: tokens.$oc-component-form-hint-gap-y;
      }

      &.--disabled {
        color: tokens.$oc-component-form-disabled-hint-color;
      }
    }
  }
</style>
